/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { campaignInvoicePaymentDataPaymentMethodSchema } from './CampaignInvoicePaymentDataPaymentMethodSchema'

export const campaignInvoicePaymentDataSchema = z.object({
	id: z.string(),
	currency: z.string(),
	amount: z.number(),
	status: z.string(),
	paidAt: z.iso.datetime().nullable(),
	paymentMethod: campaignInvoicePaymentDataPaymentMethodSchema.nullable(),
	receiptNumber: z.string().nullable(),
	metadata: z.record(z.string(), z.string()),
})

export type CampaignInvoicePaymentDataSchema = z.infer<typeof campaignInvoicePaymentDataSchema>
